import { createContext } from 'react';
import type { PickFilterDef, PickFilterValue, PickFilterValues } from '../types';

export interface PickFilterContextValue {
  filters: readonly PickFilterDef[];
  values: PickFilterValues;
  setFilterValue: (id: string, value: PickFilterValue) => void;
}

export const PickFilterContext = createContext<PickFilterContextValue | null>(null);
